import { UniversalCrud, UniversalDetail } from "@stdoutsrl/design-kit";
import { ExampleMonouseComponent } from "../tables-custom-actions/example-table-component.component";
import { api, environment } from "../../environments/environment";

// ==========================================
// 1. USERS
// ==========================================
export const users: UniversalCrud = {
  showSideNav: true, route: 'users', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  isPaginated:true,
  canAddElement: false, canEditElement: false, canDeleteElement: true,
  endpoint: "/user",
  breadcrumb: [{ title: "Utenti", route: "/users" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "nickname", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: true, type: "text" },
    { element: "email", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "email" },
    { element: "password", table: false, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "password" },
    { element: "birth_date", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: true, type: "date" },
    { 
      element: "provider", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: true, 
      type: "select", translateValue: false, selectArray: [{label: 'Email', value: 'email'}, {label: 'Google', value: 'google'}, {label: 'Meta', value: 'meta'}] 
    },
    { element: "provider_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "text" },
    { element: "email_verified", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "verification_token", table: false, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "text" },
    { element: "verification_expires_at", table: false, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "datetime" },
    { element: "profile_icon", table: true, editable: true, creation: true, filterable: false, operator: false, obligatory: true, type: "text" },
    { element: "language", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "text" },
    { element: "fiscal_code", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "text" },
    { element: "role", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "number" }
  ],
};

// ==========================================
// 2. QUIZZES
// ==========================================
export const quizzes: UniversalCrud = {
  showSideNav: true, route: 'quizzes', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: false, canDeleteElement: true,
  isPaginated:true,
  endpoint: "/quiz",
  details: { route: "quiz" },
  breadcrumb: [{ title: "Quiz", route: "/quizzes" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "title", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: true, type: "text" },
    { element: "description", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "textarea" },
    { element: "created_by", table: true, editable: false, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "is_active", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "select", selectArray:[{label:'Si',value:1},{label:'No',value:0}] },
    { element: "requires_fiscal_code", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "select", selectArray:[{label:'Si',value:1},{label:'No',value:0}]  }
  ],
};

// ==========================================
// 3. QUESTIONS
// ==========================================
export const questions: UniversalCrud = {
  showSideNav: false, route: 'questions', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/question",
  isPaginated:true,
  details: { route: "question" },
  breadcrumb: [{ title: "Domande", route: "/questions" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "quiz_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { 
      element: "type", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, 
      type: "select", translateValue: false, selectArray: [{label: 'Multiple Choice', value: 'multiple_choice'}, {label: 'Buzzer', value: 'buzzer'}, {label: 'Geoguess', value: 'geoguess'}, {label: 'Estimation', value: 'estimation'}] 
    },
    { element: "title", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "textarea" },
    { element: "media_url", table: true, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "url" },
    { element: "correct_value", table: true, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "text" },
    { element: "order_index", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" }
  ],
};

// ==========================================
// 4. QUIZ SESSIONS
// ==========================================
export const quizSessions: UniversalCrud = {
  showSideNav: false, route: 'quiz-sessions', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/quiz_sessions",
  details: { route: "session" },
  breadcrumb: [{ title: "Sessioni", route: "/quiz-sessions" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "quiz_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "host_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { 
      element: "status", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, 
      type: "select", translateValue: false, selectArray: [{label: 'Waiting', value: 'waiting'}, {label: 'Started', value: 'started'}, {label: 'Paused', value: 'paused'}, {label: 'Finished', value: 'finished'}] 
    },
    { element: "current_question_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "started_at", table: true, editable: true, creation: false, filterable: true, operator: true, obligatory: false, type: "datetime" },
    { element: "ended_at", table: true, editable: true, creation: false, filterable: true, operator: true, obligatory: false, type: "datetime" },
    { element: "join_code", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: true, type: "text" }
  ],
};

// ==========================================
// 5. QUIZ PARTICIPANTS
// ==========================================
export const quizParticipants: UniversalCrud = {
  showSideNav: false, route: 'quiz-participants', environment, api, // Nascosto dalla sideNav, meglio vederlo dal dettaglio Sessione
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/quiz_participants",
  breadcrumb: [{ title: "Partecipanti", route: "/quiz-participants" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "session_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "user_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "score", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "number" },
    { element: "joined_at", table: true, editable: true, creation: false, filterable: true, operator: true, obligatory: false, type: "datetime" },
    { element: "is_connected", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "session_token", table: true, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "text" },
    { element: "left_at", table: true, editable: true, creation: false, filterable: true, operator: true, obligatory: false, type: "datetime" }
  ],
};

// ==========================================
// 6. QUESTION OPTIONS
// ==========================================
export const questionOptions: UniversalCrud = {
  showSideNav: false, route: 'question-options', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/question_options",
  breadcrumb: [{ title: "Opzioni Domande", route: "/question-options" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "question_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "option_text", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "text" },
    { element: "is_correct", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "order_index", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" }
  ],
};

// ==========================================
// 7. ANSWERS
// ==========================================
export const answers: UniversalCrud = {
  showSideNav: false, route: 'answers', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/answer",
  isPaginated:true,
  breadcrumb: [{ title: "Risposte", route: "/answers" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "session_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "question_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "user_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "answer_text", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "text" },
    { element: "numeric_value", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "number" },
    { element: "latitude", table: true, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "number" },
    { element: "longitude", table: true, editable: true, creation: true, filterable: false, operator: false, obligatory: false, type: "number" },
    { element: "is_correct", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "response_time_ms", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "number" },
  ],
};

// ==========================================
// 8. BUZZER QUEUE
// ==========================================
export const buzzerQueue: UniversalCrud = {
  showSideNav: false, route: 'buzzer-queue', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/buzzer_queue",
  breadcrumb: [{ title: "Buzzer Queue", route: "/buzzer-queue" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "session_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "question_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "user_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "buzzed_at", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "datetime" },
    { element: "order_index", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "answered", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "was_correct", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" }
  ]
};

// ==========================================
// 9. SESSION EVENTS
// ==========================================
export const sessionEvents: UniversalCrud = {
  showSideNav: false, route: 'session-events', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/session",
  breadcrumb: [{ title: "Eventi Sessione", route: "/session-events" }],
  table: [
    { element: "id", table: true, editable: false, creation: false, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "session_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { 
      element: "event_type", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, 
      type: "select", translateValue: false, selectArray: [{label: 'Pause', value: 'pause'}, {label: 'Resume', value: 'resume'}, {label: 'Disconnect', value: 'disconnect'}, {label: 'Reconnect', value: 'reconnect'}] 
    },
    { element: "user_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" }
  ]
};

// ==========================================
// 10. QUESTION SCORES
// ==========================================
export const questionScores: UniversalCrud = {
  showSideNav: false, route: 'question-scores', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/question_scores",
  breadcrumb: [{ title: "Punteggi Domanda", route: "/question-scores" }],
  table: [
    { element: "id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "session_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "question_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "user_id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "number" },
    { element: "points", table: true, editable: true, creation: true, filterable: true, operator: true, obligatory: false, type: "number" },
    { element: "actions", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: true, type: "textarea" },
  ]
};

// ==========================================
// 11. QUESTION SETTINGS
// ==========================================
export const questionSettings: UniversalCrud = {
  showSideNav: false, route: 'question-settings', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  canAddElement: true, canEditElement: true, canDeleteElement: true,
  endpoint: "/question_settings",
  breadcrumb: [{ title: "Impostazioni Domanda", route: "/question-settings" }],
  table: [
    { element: "id", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "base_points", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "bonus_correct", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "bonus_best", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "wrong_answer_points", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "duration_seconds", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "question_delay_seconds", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "solution_delay_seconds", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "is_time_based", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "show_live_answers", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "randomize_answers", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "boolean" },
    { element: "buzzer_duration_seconds", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" },
    { element: "expected_distance_threshold", table: true, editable: true, creation: true, filterable: true, operator: false, obligatory: false, type: "number" }
  ]
};


// ==========================================
// DETAILS (Viste Master-Detail)
// ==========================================

export const quizDetail: UniversalDetail = {
  route: 'quiz', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  currentBreadcrumb: 1,
  endpoint: "/quizzes", 
  breadcrumb: [
    { title: "Quiz", route: "/quizzes" },
    { title: "Dettaglio Quiz", route: "/quizzes/:id" },
  ],
  details: quizzes.table,
  tables: [
    {
      name: "Domande", 
      endpoint: "questions", 
      active: true,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: questions.table
    }
  ]
};

export const questionDetail: UniversalDetail = {
  route: 'question', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  currentBreadcrumb: 1,
  endpoint: "/questions", 
  breadcrumb: [
    { title: "Domande", route: "/questions" },
    { title: "Dettaglio Domanda", route: "/questions/:id" },
  ],
  details: questions.table,
  tables: [
    {
      name: "Opzioni", 
      endpoint: "question_options", 
      active: true,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: questionOptions.table
    },
    {
      name: "Impostazioni", 
      endpoint: "question_settings", 
      active: false,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: questionSettings.table
    }
  ]
};

export const sessionDetail: UniversalDetail = {
  route: 'session', environment, api,
  stepMinutes: 1, showClock: true, use24h: true,
  currentBreadcrumb: 1,
  endpoint: "/quiz_sessions", 
  breadcrumb: [
    { title: "Sessioni", route: "/quiz-sessions" },
    { title: "Dettaglio Sessione", route: "/quiz-sessions/:id" },
  ],
  details: quizSessions.table,
  tables: [
    {
      name: "Partecipanti", 
      endpoint: "quiz_participants", 
      active: true,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: quizParticipants.table
    },
    {
      name: "Risposte", 
      endpoint: "answers", 
      active: false,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: answers.table
    },
    {
      name: "Buzzer Queue", 
      endpoint: "buzzer_queue", 
      active: false,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: buzzerQueue.table
    },
    {
      name: "Punteggi", 
      endpoint: "question_scores", 
      active: false,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: questionScores.table
    },
    {
      name: "Eventi", 
      endpoint: "session_events", 
      active: false,
      canAddElement: true, canEditElement: true, canDeleteElement: true,
      table: sessionEvents.table
    }
  ]
};
